export default __webpack_public_path__ + "static/media/separator.84cd7929.svg";